module.exports = __webpack_public_path__ + "static/img/about_img_vision.c938fe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/about_img_vision.png
// module id = xXqV
// module chunks = 1